import React, { createContext, useState } from 'react'

const initialEventContextValue = {
  event: null,
  login: () => {},
  logout: () => {}
}

export const EventContext = createContext(initialEventContextValue)

export const EventProvider = ({ children }) => {
  const [event, setEvent] = useState(() => {
    const storedEvent = localStorage.getItem('event')
    return storedEvent ? JSON.parse(storedEvent) : null
  })

  const login = (eventData) => {
    setEvent(eventData)
    localStorage.setItem('event', JSON.stringify(eventData))
  }

  const logout = () => {
    setEvent(null)
    localStorage.removeItem('event')
  }

  return <EventContext.Provider value={{ event, login, logout }}>{children}</EventContext.Provider>
}

const initialSessionContextValue = {
  session: null,
  loginSession: () => {},
  logoutSession: () => {}
}

export const SessionContext = createContext(initialSessionContextValue)

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState(() => {
    const storedSession = localStorage.getItem('session')
    return storedSession ? JSON.parse(storedSession) : null
  })

  const loginSession = (sessionData) => {
    setSession(sessionData)
    localStorage.setItem('session', JSON.stringify(sessionData))
  }

  const logoutSession = () => {
    setSession(null)
    localStorage.removeItem('session')
  }

  return (
    <SessionContext.Provider value={{ session, loginSession, logoutSession }}>
      {children}
    </SessionContext.Provider>
  )
}
